import React from 'react'
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'

const styles = {
  footer: {
    flexGrow: 0,
    height: 30,
    color: '#FFF',
    marginTop: 10,
    textTransform: 'capitalize',
    textShadow: '0 2px 3px black',
  },
}

const Footer = props => {
  const { classes, name } = props
  const date = new Date().getFullYear()
  return (
    <Typography variant="subheading" className={classes.footer} align="center">
      {name} © All rights reserved {date}
    </Typography>
  )
}

export default withStyles(styles)(Footer)


// WEBPACK FOOTER //
// ./src/components/Footer.js